/*global _api*/
import store from '@/store/'
import { global } from '@/global';
import router from '@/router/'
import axios from 'axios'
import { userAgent } from '@/helpers'

export let INDIVIDUAL = axios.create({
	baseURL: _api.individual,
	headers: {
		Authorization: store.getters.getAccessToken,
		'UserAgent': userAgent()
	},
	timeout: 0
});

const refreshAccessToken = () => {
	let form = {
		UserAgent: userAgent(),
		refreshToken: store.getters.getRefreshToken
	}
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.individual}/Authentication/RefreshToken`, form, {
			headers: {
				'UserAgent': userAgent()
			}
		})
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

INDIVIDUAL.interceptors.response.use(response => {

	return response

}, async error => {


	if (error.response.status == 403) {

		const originalRequest = error.config;

		originalRequest._retry = true;

		await refreshAccessToken().then(response => {

			axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.result.accessToken;
			INDIVIDUAL.defaults.headers.common['Authorization'] = 'Bearer ' + response.result.accessToken;

			store.dispatch("setAccessToken", response.result.accessToken);
			store.dispatch("setRefreshToken", response.result.refreshToken);

			sessionStorage.setItem(global["ACCESS_TOKEN"], response.result.accessToken);
			sessionStorage.setItem(global["REFRESH_TOKEN"], response.result.refreshToken);

			axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.access_token;

			return INDIVIDUAL(originalRequest);

		}).catch(() => {
			store
				.dispatch("logout")
			store
				.dispatch("deletechat")
				.then(() => router.push('/login/individual'));
		});
	}

	return Promise.reject(error.response.data);
})